import { render, staticRenderFns } from "./BotaoMonitoramentoAgricola.vue?vue&type=template&id=50a76945&lang=pug"
import script from "./BotaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BotaoMonitoramentoAgricola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports